import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Select } from 'formlabs-web-components/Form';

import { getIndustries, getFactorySolutionsIndustries } from './SelectOptions';
import { sortWithLocale } from '../../../utils';
import CountryContext from '../../../context/country';

const IndustrySelect = ({ factorySolutions = false, ...props }) => {
  const { t } = useTranslation();
  const { language } = useContext(CountryContext);

  const entries = factorySolutions
    ? getFactorySolutionsIndustries(t)
    : getIndustries(t);

  return (
    <Select {...props}>
      <option value="">– {t('Select')} –</option>
      {sortWithLocale(entries, language).map(industry => (
        <option key={industry.value} value={industry.value}>
          {industry.text}
        </option>
      ))}
    </Select>
  );
};

IndustrySelect.defaultProps = { defaultValue: '' };
export default IndustrySelect;
